import Icon from '../components/Icon.vue'

Icon.register({
  tram: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 64C305.7 64 320 49.7 320 32S305.7 0 288 0 256 14.3 256 32 270.3 64 288 64zM511.5 51.9C509.2 43.3 500.5 38.3 491.9 40.6L11.9 168.6C3.4 170.9-1.7 179.6 0.6 188.2 2.5 195.3 8.9 200 16 200 17.4 200 18.8 199.8 20.1 199.5L240 140.8V224H64C46.3 224 32 238.3 32 256V480C32 497.7 46.3 512 64 512H448C465.7 512 480 497.7 480 480V256C480 238.3 465.7 224 448 224H272V132.3L500.1 71.5C508.7 69.2 513.7 60.4 511.5 51.9zM176 384H80V288H176V384zM336 288H432V384H336V288zM304 288V384H208V288H304zM192 96C209.7 96 224 81.7 224 64S209.7 32 192 32 160 46.3 160 64 174.3 96 192 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tram.js
// module id = EgqC
// module chunks = 144